import { IPriorityCount } from 'volta/models/types/stats';

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type DashboardSummary from 'volta/models/dashboard-summary';

interface IArgs {
  dashboardSummary?: DashboardSummary;
  dashboardSummaryLoading?: boolean;
  onFilterPlannings?: (priority: string) => void;
  onFilterAlerts?: (priority: string, zoneType: string) => void;
}

export default class PlanningKpisShortcutWidget extends Component<IArgs> {
  @tracked alertsDetailsCollapsed: boolean = true;

  levels: Array<keyof IPriorityCount> = ['critical', 'high', 'medium', 'low', 'otog'];

  colsClassNames: Record<keyof IPriorityCount, string> = {
    critical: 'col-6 col-md u-pr-2 u-mb-2 u-mb-md-0',
    high: 'col-6 col-md u-pr-0 u-pr-sm-2 u-mb-2 u-mb-md-0',
    medium: 'col-4 col-md u-pr-2 u-mb-2 u-mb-md-0',
    low: 'col-4 col-md u-pr-2 u-mb-2 u-mb-md-0',
    otog: 'col-4 col-md u-pr-2 u-mb-2 u-mb-md-0'
  };

  get planningKpis() {
    return this.levels.map((level, index) => ({
      level,
      currentValue: this.args.dashboardSummary?.planningCounts[level],
      previousValue: this.args.dashboardSummary?.data.planningPrevCounts[index]
    }));
  }

  get executionKpis() {
    return [
      {
        bgColor: 'critical',
        color: 'red-6',
        label: 'critical',
        value: this.args.dashboardSummary?.executionCriticalCount,
        previousValue: this.args.dashboardSummary?.executionCriticalCountPrev
      },
      {
        bgColor: 'red',
        color: 'red',
        label: 'high',
        value: this.args.dashboardSummary?.executionHighCount,
        previousValue: this.args.dashboardSummary?.executionHighCountPrev
      },
      {
        bgColor: 'yellow',
        color: 'yellow',
        label: 'medium',
        value: this.args.dashboardSummary?.executionMediumCount,
        previousValue: this.args.dashboardSummary?.executionMediumCountPrev
      },
      {
        bgColor: 'success',
        color: 'success',
        label: 'low',
        value: this.args.dashboardSummary?.executionLowCount,
        previousValue: this.args.dashboardSummary?.executionLowCountPrev
      },
      {
        bgColor: 'teal',
        color: 'teal',
        label: 'otog',
        value: this.args.dashboardSummary?.executionOtogCount,
        previousValue: this.args.dashboardSummary?.executionOtogCountPrev
      }
    ];
  }

  get onHandAlertsKpis() {
    return this.levels.map((level) => ({
      level,
      currentValue: this.args.dashboardSummary?.ohaCounts[level],
      previousValue: this.args.dashboardSummary?.prevOhaCounts[level]
    }));
  }

  get projectedOnHandAlertsKpis() {
    return this.levels.map((level) => ({
      level,
      currentValue: this.args.dashboardSummary?.projectedOhaCounts[level],
      previousValue: this.args.dashboardSummary?.projectedOhaCounts[level]
    }));
  }
}
